import { buttonStyles } from "../button/button-styled";
import { DEFAULT_VARIANT } from "../button/constants";
import styled, { css } from "../styled";
import BaseLink from "./link";
const variantStyleSelector = ({ variant = DEFAULT_VARIANT, theme, }) => {
    const { colors } = theme._ui;
    const styles = {
        primary: `color: ${colors.accent.text.default};`,
        secondary: `color: ${colors.surface.text.default};`,
        inverse: `color: ${colors.inverse.text.default};`,
    };
    return styles[variant];
};
export const BaseStyledLink = styled(BaseLink) `
  text-decoration: none;
`;
export const Link = styled(BaseLink) `
  text-decoration: none;

  display: inline-flex;
  align-items: center;
  gap: ${(props) => props.theme._ui.space.s1};

  & > svg {
    flex-shrink: 0;
    height: 1em;
    width: 1em;
  }

  cursor: not-allowed; // For disabled
  :not([aria-disabled]) {
    cursor: pointer;
  }

  ${(props) => {
    if (props.type === "text" || props.type === undefined) {
        return css `
        :not([aria-disabled], :has(*)):hover {
          text-decoration: underline;
        }

        ${variantStyleSelector}
      `;
    }
    if (props.type === "button") {
        // The type logic gets lost going through the styled components layer so it has
        // to be ignored here. The typing works fine on the unstyled base component.
        // @ts-expect-error
        // prettier-ignore
        return css `${buttonStyles}`;
    }
}}
`;
export default Link;
